import type { PageLayoutSchema } from '@workspace/lib/types/page-layout-schema';

export const pageLayoutSchema: PageLayoutSchema = {
  navbar: {
    primaryText: 'Other.pageLayout.navbar.primaryText',
    secondaryText: 'Other.pageLayout.navbar.secondaryText',
    callCostNote: 'Other.pageLayout.navbar.callCostNote',
    logoutButtonText: 'Other.pageLayout.navbar.logOut',
    phoneNumber: 'Other.pageLayout.navbar.phoneNumber',
  },
  customerService: {
    title: 'Other.pageLayout.customerServiceBox.title',
    phoneLabel: 'Other.pageLayout.customerServiceBox.phoneLabel',
    phone: '0213010707',
    note: 'Other.pageLayout.customerServiceBox.note',
  },
};
